import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('红包名称为1-30位中文'))
    } else {
        callback();
    }
}

export const redPacketTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "红包名称",
        prop: "redPacketName",
        search: true,
        type: 'input',
        rules: [{
            required: true,
            trigger: "blur",
            validator: validateName
        }]
        },
        {
            label: "红包类型",
            prop: "redPacketType",
            type: "select",
            dicData: DIC.SALES_RED_PACKED_TYPE,
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择红包类型"
            }]
        },
        {
            label: "领取方式",
            prop: "payment",
            type: "select",
            dicData: DIC.SALES_RED_PACKED_PAYMENT,
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择领取方式"
            }]
        },
        {
            label: "红包金额",
            prop: "redPacketTotal",
            type: 'input',
            rules: [{
                trigger: "blur",
                required: true,
                message: "请输入红包金额"
            }]
        },
        {
            label: "红包个数",
            prop: "redPacketNumber",
            type: 'number',
            rules: [{
                trigger: "blur",
                required: true,
                message: "请输入红包个数"
            }]
        },
        {
            label: "有效期",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            formatter: function(row, value , label, column){
                return formatterTime(row.startDate) +'至'+formatterTime(row.endDate)
            }
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            // formsolt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "创建时间",
        //     prop: "createTime",
        //     type: "datetime",
        //     sortable: true,
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATE
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};